<template>
  <form class="login-form absa-form" @submit.prevent="proceed" v-show="loaded">
    <div class="content-section">
      <absa-pay-logo />

      <h3 style="text-align: center">Verify your Absa account</h3>
      <p>Enter your registered {{ selectedInputConfig.label }} to verify</p>
    </div>
    <div class="inputs-section">
      <!-- User Input -->
      <div class="input-block">
        <pf-input
          id="absa"
          :placeholder="`Enter ${selectedInputConfig.label}`"
          v-model="identifierValue"
          :disabled="isAbsaPayHighRiskTransaction"
        >
          <span>{{ selectedInputConfig.label }}</span>
        </pf-input>
        <div class="pay-button">
          <proceed-button
            :is-proceed-enable="canProceed()"
            :is-loading="this.isLoading"
          />
        </div>
      </div>
    </div>
    <div class="inputs-switch" v-if="!isAbsaPayHighRiskTransaction">
      <p>I would like to use my</p>
      <span
        v-for="(input, key) in inputConfig.filter(
          ({ key: configKey }) => configKey !== identifierKey
        )"
        :key="key"
      >
        <span @click="setIdentifierKey(input.key)" class="underlined">{{
          input.label
        }}</span>
        <!-- Minus 2 from count to take into account that 1 option will be active -->
        <span v-if="key !== inputConfig.length - 2"> | </span>
      </span>
    </div>
    <br />
    <div class="notification">
      <p class="note">
        <span><img src="../assets/images/info.svg" alt="info" /></span> Please
        note
      </p>
      <p class="disclaimer">
        Payfast by Network and Absa are enabling a safe and secure method of
        paying from your bank account. Payfast by Network will not access your
        bank account on your behalf.
      </p>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import { mapState } from 'vuex'
import PfCustomInput from '../components/CustomInput.vue'
import axios from '@/wrapper'
import loadingManager from '@/LoadingManager'
import AbsaPayLogo from '@/components/AbsaPayLogo'
import Constants from '@/constants'
import { maskInput } from '@/utils'

export default {
  name: 'AbsaPayBankForm',
  mixins: [formMixin],
  components: {
    pfInput: PfCustomInput,
    AbsaPayLogo,
  },
  data() {
    return {
      loaded: false,
      inputConfig: Object.values(Constants.absaPayInputConfig),
      identifierKey: Constants.absaPayInputConfig.id.key,
      identifierValue: '',
    }
  },
  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapState('merchantSettings', ['isAbsaPayHighRiskTransaction']),
    ...mapState('signalRMessage', ['message']),
    selectedInputConfig() {
      return this.inputConfig.find((input) => input.key === this.identifierKey)
    },
    initialIdentifierKey() {
      // get default
      let config = this.inputConfig.find((item) => item.key === 'SAID')

      if (this.isAbsaPayHighRiskTransaction)
        config = this.inputConfig.find((input) => input.isHighRiskDefault)
      return config.key
    },
  },
  mounted() {
    //set default value for the identifierKey and if highrisk set the value for the key..

    this.loaded = true
    this.identifierKey = this.initialIdentifierKey //set default
    this.identifierValue = this.isAbsaPayHighRiskTransaction
      ? maskInput(this.transaction.idNumber)
      : ''
  },
  methods: {
    validateRegex() {
      const valueToCheck = this.isAbsaPayHighRiskTransaction
        ? this.transaction.idNumber
        : this.identifierValue
      return this.selectedInputConfig.regex.test(valueToCheck)
    },
    canProceed() {
      return this.validateRegex()
    },
    setIdentifierKey(key) {
      this.identifierKey = key
    },
    async proceed() {
      if (!this.canProceed()) {
        return false
      }
      this.$emit('closeErrorMessage')
      let errorMessage = ''
      this.isLoading = true

      await axios
        .post('bankApi/absaPay/consent', {
          transactionId: this.transaction.id,
          IdentifierKey: this.identifierKey,
          IdentifierValue: this.isAbsaPayHighRiskTransaction
            ? this.transaction.idNumber
            : this.identifierValue,
        })
        .then((response) => {
          if (response.data.HasErrors) {
            errorMessage =
              response.data.ErrorMessages[0].ErrorMessage ?? errorMessage
          } else {
            this.message.instruction.message =
              'Please wait while we connect you to Absa'
            loadingManager.setLoading(true)
          }
        })
        .catch((err) => {
          this.$handleException({ err, transactionId: this.transaction.id })
        })

      if (errorMessage !== '') {
        this.$emit('setError', errorMessage)
        this.isLoading = false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.absa-form {
  .notification {
    margin: 0 auto;
    text-align: center;
    border-radius: 8px;
    background: #d2cdcd1a;
    padding: 1px 20px;

    .note {
      font-weight: 700;

      span {
        margin-right: 2px;
      }
    }

    .disclaimer {
      font-size: 12px;
    }
  }

  .input__label span {
    font-size: 14px;
    font-weight: bold;
  }

  input#absa {
    margin-top: 8px;
  }

  .content-section {
    h3 {
      text-align: center;
      font-weight: 700;
    }

    p {
      text-align: center;
      font-size: 14px;
    }
  }

  .pay-button {
    justify-content: center;
    min-width: 320px;
  }

  .input-block {
    align-items: center;
    margin: 30px 0 15px;
  }
  .inputs-switch {
    font-family: Founders Grotesk, serif;
    font-weight: 400;
    font-size: 16px;
    text-align: center;

    .underlined {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
